(function ($) {
    'use strict';
    /**
     * плагин ширины для таймов
     * */
    $.fn.timelineWidth = function () {
        var $self = $(this);
        var classes = {
            mainTime: '.js-timeline-main',
            overTime: '.js-timeline-overtime',
        };
        var hasOvertimeClass = 'with-overtime';
        var $mainTime = $self.find(classes.mainTime);
        var $overTime = $self.find(classes.overTime);
        var timeLengthMainTimeline = $self.data('timemain') ? $self.data('timemain') : 90;
        var countMainTime = $self.data('countmain') ?  $self.data('countmain') : 2;
        var allTimeOvertime = $self.data('timeextra');
        var countExtraTime = $self.data('countextra') ? $self.data('countextra') : 2;
        var timeLengthOvertime = allTimeOvertime / countExtraTime;
        var allTimeMatch = timeLengthMainTimeline + allTimeOvertime;
        var numberAllTime = $self.hasClass(hasOvertimeClass) ? (countMainTime + countExtraTime) : countMainTime;
        var gapLine = 2;

        /**
         * получаем отступ для вычинания в calc
         * @returns {string}
         */
        var getWidthGapForAveryItem = function () {
            return gapLine * (numberAllTime - 1) / numberAllTime + 'px';
        };

        /**
         * получаем ширину
         * @param name
         * @returns {string}
         */
        var getWidthTime = function (name) {
            var width = (name / allTimeMatch * 100).toString() + '%';
            return 'calc(' + width + ' - ' +  getWidthGapForAveryItem() + ')';
        };

        /**
         * инициализация плагина
         * */
        var init = function () {
            $mainTime.each(function () {
                $(this).css({width: getWidthTime(timeLengthMainTimeline / countMainTime)});
            });
            if ($overTime && $overTime.length > 0) {
                $overTime.each(function () {
                    $(this).css({width: getWidthTime(timeLengthOvertime)});
                });
            }
        };
        init();
        return this;
    };
    $('.js-timeline-wrapper').each(function () {
        $(this).data('timelineWidth', $(this).timelineWidth());
    });
})(jQuery);
